import React, { useState, useEffect } from 'react';
import {
    Button, Alert, Row, Col,
    FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import AccountSelect from '../Account/AccountSelect';
import AccountCard from '../Account/AccountCard';
import { getAccounts, getLinkedAccounts, addLinkedAccount, removeLinkedAccount } from '../../API';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faAsterisk, faCreditCard, faHome } from '@fortawesome/free-solid-svg-icons';

function LinkAccounts(props) {
    const [searchOptions, setSearchOptions] = useState({ active: 1, exactAccountNumber: true, accountNumber: '' });
    const [isSearching, setIsSearching] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorVisible, setErrorVisible] = useState(false);
    const [selectedAccounts, setSelectedAccounts] = useState([]);
    const [linkedAccounts, setLinkedAccounts] = useState([]);
    const [isLoadingLinkedAccounts, setIsLoadingLinkedAccounts] = useState(true);
    const [accountSelectModal, setAccountSelectModal] = useState(false);

    const linkAccount = async () => {
        setIsSearching(true);
        setErrorVisible(false);
        try {
            const searchAPIResults = await getAccounts(searchOptions);
            if (searchAPIResults.length > 0) {
                const linkAccountId = searchAPIResults[0].accountID;
                if (!props.linkedAccounts.find(l => l.accountID == linkAccountId)) {
                    await addLinkedAccount(linkAccountId);
                    props.fetchLinkedAccounts();
                }
            } else {
                openErrorMessage(<div>Couldn't find account, <strong>{searchOptions.accountNumber}</strong>.</div>);
            }
        } catch (ex) {
            openErrorMessage(<div>Unable to link account, <strong>{searchOptions.accountNumber}</strong>.</div>);
        } finally {
            setIsSearching(false);
        }
    };

    const goToHome = () => {
        props.history.push('/home');
    }

    const goToPayFees = () => {
        props.history.push('/payFees');
    }

    const updateSearch = e => {
        setSearchOptions({
            ...searchOptions,
            [e.target.name]: e.target.value
        });
    };

    const unlinkAccount = async (accountId) => {
        setErrorVisible(false);
        await removeLinkedAccount(accountId);
        props.fetchLinkedAccounts();
    };

    const openErrorMessage = (error) => {
        setErrorMessage(error);
        setErrorVisible(true);
    }

    const accountCardOptions = {
        fields: {
            active: false,
            accountNumber: true,
            account: true,
            contact: true,
            address: true,
            email: true,
            balance: false
        },
        actions: {
            view: false,
            edit: false,
            makePayment: false,
            generateLetter: false,
            delete: false,
            select: false,
            cancel: false,
            unlink: true,
        }
    };

    const errorMessageJSX = (<Alert color="danger" isOpen={errorVisible} toggle={() => setErrorVisible(false)}>{errorMessage}</Alert>);

    let accountsJSX = null;
    if (props.isLoadingLinkedAccounts || isSearching) {
        accountsJSX = (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>);
    } else if (props.linkedAccounts !== null) {
        if (props.linkedAccounts.length > 0)
            accountsJSX = (<div>
                {props.linkedAccounts.map(o => (<AccountCard account={o} key={o.accountID} options={accountCardOptions} unlink={unlinkAccount} />))}
                <div className="home-button">
                    <Button className="btn-icon" color="danr-blue" onClick={goToHome}><FontAwesomeIcon icon={faHome} /><span>Back Home</span></Button>
                </div>
            </div>);
        else
            accountsJSX = (<div>No account linked.</div>);
    }

    return (
        <div id="linkAccounts">
            <Row className="header-row">
                <Col>
                    <h1>Link Accounts</h1>
                </Col>
            </Row>
            <Row className="header-row">
                <Col>
                    <div className="link-accounts-input">
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><FontAwesomeIcon icon={faAsterisk} /></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Account Number" name="accountNumber" value={searchOptions.accountNumber || ''} onChange={updateSearch} />
                            </InputGroup>
                        </FormGroup>
                        <FormGroup>
                            <Button className="btn-icon" color="danr-blue" onClick={linkAccount}><FontAwesomeIcon icon={faLink} /><span>Link Account</span></Button>
                        </FormGroup>
                    </div>
                    {errorMessageJSX}
                    {accountsJSX}
                </Col>
            </Row>
        </div>
    );
}

export default LinkAccounts;